import React, { useRef, useEffect, useState } from 'react';
import { Grid } from "@mui/material";
import { BtnSave } from "components/Button/ButtonAll";
import UploadFile from "components/Input/UploadFile";

import { Extension, FnAxios, FnDialog } from "utilities/utilities";

const MigrateProject = () => {
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog()
    const [arrExcelFile, setArrExcelFile] = useState([]);
    const handleClearAttachFile = useRef(null)

    const onSubmit = (e) => {
        let param = {
            lstFileUpload: arrExcelFile ?? [],
        };
        DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`ProjectDashboard/SaveDataProject`, param, (result) => {
                DialogFn.UnBlockUI();
                DialogFn.Success(`บันทึกสำเร็จ`);
                DialogFn.CloseSubmit()
            }, (err) => {

                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    return (
        <>
            <Grid item xs={12} md={12} key={"cccc"}>
                <UploadFile
                    id="sGalleryFile"
                    name={"sGalleryFile"}
                    label={""}
                    required={false}
                    arrFile={arrExcelFile || []}
                    setarrFile={setArrExcelFile}
                    sFolderTemp="FolderExample"
                    IsFolder={false}
                    IsMultiple={false}
                    Extension={[...Extension.Excel]}
                    nLimitFile={30}
                    sLimitFile={"MB"}
                    onClearFile={handleClearAttachFile}
                    sPositionText="right"
                    IsCrop={false}
                    cropMovable={false}
                    cropResize={false}
                    cropShape="retangle"
                    modeDisplay='list'
                    key={"sGalleryFile"}

                />
            </Grid>
            <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                <Grid container item xs={6} md={6} justifyContent="flex-end">
                    <BtnSave
                        id={"btnSave"}
                        onClick={(e) => onSubmit(e)}
                    />
                </Grid>
            </Grid>
          
        </>
    );
}
export default MigrateProject